import {css} from 'emotion'

export const UserChallengeStyle = css({
  padding: '0rem 2rem 4rem 2rem',
  '@media (min-width: 1024px)': {
    padding: '0rem 8rem 8rem 8rem',
  },
  '.user-challenge': {
    '&-push': {
      maxWidth: 'calc(1/2 * 100%)',
      flexBasis: 'calc(1/2 * 100%)',
      '@media (min-width: 1024px)': {
        maxWidth: 'calc(1/4 * 100%)',
        flexBasis: 'calc(1/4 * 100%)',
      },
      '& > div:first-child' : {
        padding: '2rem 0px',
        '@media (min-width: 1024px)': {
          padding: '3rem 0px',
        },
      },
    },
    '&-charts': {
      textTransform: 'uppercase',
      fontWeight: 'bold',
      marginTop: '2rem',
      '@media (min-width: 1024px)': {
        marginTop: 0
      },
      'canvas': {
        margin: '2rem 0',
        width: '100%',
        height: '250px',
        '@media (min-width: 1024px)': {
          height: '600px',
        },
      }
    },
  },
})


// WEBPACK FOOTER //
// ./src/styles/containers/challenge.js